const SERVICE = 'case-service'

const getConsultationsListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/case', params)

const getAvailableConsultationsListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/status', params)

const postConsultationApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/case')

const getConsultationsHistoryListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/user', params)

const getConsultationHistoryDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/case/${id}`)

const assignDocToConsultationApi = async (api, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/doctor/${id}/assign`)

const getDoctorConsultationsHistoryListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/doctor', params)

const getDoctorConsultationHistoryDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/doctor/${id}`)

const setConsultationPreferenceApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/case/${id}`)

module.exports = {
  getConsultationsListApi,
  postConsultationApi,
  getConsultationsHistoryListApi,
  getConsultationHistoryDetailsApi,
  getDoctorConsultationsHistoryListApi,
  getDoctorConsultationHistoryDetailsApi,
  getAvailableConsultationsListApi,
  assignDocToConsultationApi,
  setConsultationPreferenceApi,
}
